import { FilterState, WithEmbeddings } from "@/utilityTypes";
import { Match } from "@/entities/Match/Match.types";

export type Deal = {
    id: string;
    companyName?: string;
    icmCompanyId?: number;
    companyId: string;
    teaserProfileToken: string;
    name: string;
    fundraisingAmountMax: number;
    fundraisingAmountMin: number;
    status: string;
    createdAt: string;
    dataroomLink?: string;
};

export type DealFilter = {
    searchTerm?: string;
    status?: FilterState;
};

export type DealWithEmbeddings = WithEmbeddings<
    Deal,
    { embedding: "matches"; type: Match[] }
>;
